import { formatMoney } from "../../toll/money";
import { campaignEarnedMedal } from '../../toll/campaignRules';
import { observer } from "mobx-react-lite";
import CampaignDeadline from "../../components/CampaignDeadline";
import { useMemo } from "react";
import { fundraising_campaign_bigger_enter_button, goal_coin_small } from "../../imgs";
import { MyColor } from "../../config/myStyle";
import { GetCampaignRes } from "../../api";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { campaignThemeStore, userStore } from "../../stores";
import { getCampaignThemeImages } from "../../toll/campaignThemeVisual";

type MyRecordCampaignItemProps = {
  campaign: GetCampaignRes
  className?: string
}

const MyRecordCampaignItem = observer((props: MyRecordCampaignItemProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const themeName = useMemo(() => {
    const theme = campaignThemeStore.campaignThemeDataList?.items?.find(item => item.id === props.campaign.campaignThemeId);
    const locale = userStore.language ?? "zh-HK";
    return theme?.nameObj?.[locale] ?? theme?.name;
  }, [props.campaign.campaignThemeId]);
  const { profile } = useMemo(() => getCampaignThemeImages(props.campaign, themeName), [props.campaign, themeName]);

  const campaign = props.campaign
  const ratioAmount = (campaign.raisedAmount / campaign.goalAmount * 100).toFixed(0)

  const onClick = () => {
    navigate(`/my-record/${props.campaign.id}`)
  }

  return (
    <div
      className={`items-center flex bg-[white] p-[12px] ${props.className ?? ''}`}
      style={{
        borderRadius: 28,
        borderWidth: 4,
        borderColor: MyColor.sub,
        position: 'relative',
        marginTop: campaignEarnedMedal(campaign) ? 28 : undefined,
      }}
    >
      {campaignEarnedMedal(campaign) && (
        <>
          <div style={{
            position: 'absolute',
            left: 0,
            top: 0,
            overflow: 'hidden',
          }}>
            <div
              className="size-[100px] bg-[#BE9E73]"
              style={{
                position: 'absolute',
                left: -50,
                top: -50,
                transform: 'rotate(45deg)',
              }}
            />
          </div>
          <img
            className="size-[54px]"
            src={goal_coin_small}
            style={{
              position: 'absolute',
              top: 8,
              left: 8,
              borderRadius: '50%',
            }}
            alt=""
          />
        </>
      )}
      <img src={profile} className="size-[92px] rounded-full border-[4px] border-[#1E4A97] bg-[white]" alt="" />
      <div className="px-[10px] flex-1">
        {/* 标题 */}
        <div className="line-clamp-2 text-[18px] font-[700]" style={{ color: MyColor.blue, lineHeight: 1.16 }}>{campaign.title}</div>
        {/* 进度条 */}
        <div className="flex mt-[10px]" style={{ position: 'relative' }}>
          <div className="bg-[rgba(0,0,0,0.2)] flex-1 h-[8px] rounded-full" style={{ position: 'relative', overflow: 'hidden' }}>
            <div className="h-[8px] absolute" style={{ width: `${ratioAmount}%`, backgroundColor: MyColor.red }} />
          </div>
        </div>
        {/* raised so far */}
        <div className="text-[rgba(0,0,0,0.7)] text-[14px] font-[500] leading-[1.2] mt-[8px]" >
          <div style={{ opacity: 0.9 }}>{t('my_record_campaign_item.raised_so_far')}</div>
          <div className="font-[700] text-[26px] text-[#666666]">
            HK$ {formatMoney(campaign?.raisedAmount)}
          </div>
        </div>
        <div className="mt-[6px] h-[1.5px] bg-[rgba(0,0,0,0.28)] " />
        {/* foot */}
        <div className="flex text-[rgba(0,0,0,0.6)] text-[13px] font-[600] mt-[10px]" style={{ alignItems: 'center', justifyContent: 'space-between', lineHeight: 1.2 }}>
          <div className="flex gap-[22px]">
            <div>
              <div style={{ fontWeight: 600 }}>
                {ratioAmount}%
              </div>
              <div>
                {t('my_record_campaign_item.funded')}
              </div>
            </div>
            <div>
              <CampaignDeadline endDate={campaign?.expectedEndDate} stacked />
            </div>
          </div>
          <img onClick={onClick} style={{ zIndex: 1 }} className="size-[50px]" src={fundraising_campaign_bigger_enter_button} alt="" />
        </div>
      </div>
    </div>
  );
});

export default MyRecordCampaignItem;
